module.exports = __webpack_public_path__ + "static/portfolio_formations-fs8-c2678989e71ee7c6e7cbe9f85e655947.png";